import React, { useState, useEffect, useMemo } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import axiosInstance from "../utills/axiosInstance";
import "./TemplatePreview.css";
import generatePDF from "../utills/GenerateOfferLetter";

const TemplatePreview = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const candidateData = location.state?.candidateData;
    const profile = useMemo(() => JSON.parse(localStorage.getItem('profile') || '{}'), []);

    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const sampleData = {
        fullName: "John Doe",
        location: "Chennai",
        department: "Administration",
        designation: "Manager",
        candidateType: "Full-time",
        presentAddress: "Velachery, Chennai",
        workPhoneNumber: "9876543210",
        dateOfJoining: new Date().toLocaleDateString(),
        currentDate: new Date().toLocaleDateString(),
        joinDate: new Date().toLocaleDateString(),
        hrName: "Jochith",
        hrMail: "jochith@marsforce.com"
    };

    const buildPdfData = (candData) => ({
        firstName: candData.firstName,
        lastName: candData.lastName,
        fullName: `${candData.firstName} ${candData.lastName}`,
        department: candData.department,
        designation: candData.designation,
        location: candData.location,
        candidateType: candData.candidateType,
        presentAddress: candData.presentAddress,
        workPhoneNumber: candData.workPhoneNumber,
        dateOfJoining: candData.dateOfJoining,
        currentDate: new Date().toLocaleDateString(),
        joinDate: new Date(candData.dateOfJoining).toLocaleDateString(),
        hrName: `${profile.firstName || ''} ${profile.lastName || ''}`.trim(),
        hrMail: profile.email || '',
    });

    const dataToUse = candidateData ? buildPdfData(candidateData) : sampleData;
    const isPreviewMode = !candidateData || Object.keys(candidateData).length === 0;

    useEffect(() => {
        const fetchTemplate = async () => {
            try {
                const res = await axiosInstance.get(`/api/templates/${id}`);
                setTemplate(res.data);
            } catch (err) {
                setError("Failed to load template.");
            } finally {
                setLoading(false);
            }
        };
        fetchTemplate();
    }, [id]);

    const handleGenerate = () => {
        if (candidateData) {
            const pdfData = buildPdfData(candidateData);
            generatePDF(template, pdfData);
        }
    }

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    if (!template) return <div>Template not found.</div>;

    const previewContent = template.sections.map((section, secIdx) => (
        <div key={secIdx} className="preview-section">
            {section.heading && <h4 className="preview-heading">{section.heading}</h4>}
            {section.paragraphs.map((para, paraIdx) => {
                const replaced = para.replace(/\{([^}]+)\}/g, (match, key) => {
                    const value = dataToUse[key];
                    if (isPreviewMode || !value) {
                        return `<span class="placeholder">[${key}: ${value || 'N/A'}]</span>`;
                    }
                    return value;
                });
                return <p key={paraIdx} dangerouslySetInnerHTML={{ __html: replaced }} className="preview-paragraph" />;
            })}
        </div>
    ));

    return (
        <div className="template-preview-container">
            <div className="preview-header">
                <h2>{template.name} {isPreviewMode ? '(Preview Mode)' : '(Generated with Candidate Data)'}</h2>
                <div className="header-actions">
                    <button 
                    onClick={handleGenerate}
                    disabled={isPreviewMode}
                    className="btn btn-primary"
                    >
                        Generate Offer Letter
                    </button>
                    <button onClick={() => navigate('/templates', { state: { candidateData } })} className="btn btn-secondary">Back to Templates</button>
                </div>
            </div>
            <div className="preview-pages-wrapper">
                <div className="preview-page">
                    <div className="preview-body">
                        <h2>OFFER LETTER</h2>
                        <p><strong>Date:</strong> {dataToUse.currentDate}</p>
                        <p><strong>To:</strong> Mr. {dataToUse.fullName}</p>
                        <p><strong>Address:</strong> {dataToUse.presentAddress}</p>
                        <p><strong>Phone:</strong> {dataToUse.workPhoneNumber}</p>
                        <p><strong>Sub:</strong> Offer Letter</p>
                        <p>Dear {dataToUse.fullName},</p>
                        {previewContent}
                        <p>With regards,<br />{dataToUse.hrName}<br />{dataToUse.hrMail}<br />HR - Head</p>
                        <div className="preview-footer">
                            <p>
                                Acceptance: I will join on {dataToUse.joinDate}.<br />
                                Name: {dataToUse.fullName}<br />
                                Signature: _________________<br />
                                Date: ______________________
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .placeholder { background: yellow; font-weight: bold; padding: 2px 4px; }
            `}</style>
        </div>
    );
};

export default TemplatePreview;
